




import app from "@/app";
import { SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSurveyEdit extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	title = "SX_LANG_SURVEY_EDIT";

	get form() {
		return getForm(this.survey);
	}
	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [SXSurvey.COL_NAME, SXSurvey.COL_DESCRIPTION],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let item = new SXSurvey(this.survey.toObject()),
				data: any = {};

			[
				SXSurvey.COL_NAME,
				SXSurvey.COL_DESCRIPTION,
				SXSurvey.COL_REQUIRE_USER,
				SXSurvey.COL_VISIBILITY
			].forEach(function(name) {
				data[name] = fv.getField(name);
			});

			if (!fv.getField(SXSurvey.COL_VISIBILITY)) {
				data[SXSurvey.COL_VISIBILITY] = false;
			}
			if (!fv.getField(SXSurvey.COL_REQUIRE_USER)) {
				data[SXSurvey.COL_REQUIRE_USER] = false;
			}

			if (!item.doHydrate(data).isClean()) {
				app.services.surveys.updateItem(item, function() {
					app.router.goBack();
				});
			} else {
				app.router.goBack();
			}
		}
	}
}

const getForm = function(survey: SXSurvey) {
	return {
		fields: {
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXSurvey.COL_NAME,
					minlength: 3,
					maxlength: 60,
					autocomplete: "off",
					value: survey.name
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXSurvey.COL_DESCRIPTION,
					minlength: 3,
					value: survey.description
				}
			},
			require_user: {
				field: "checkbox",
				label: { i18n: "SX_LANG_REQUIRE_USER" },
				attrs: {
					name: SXSurvey.COL_REQUIRE_USER,
					checked: survey.require_user
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXSurvey.COL_VISIBILITY,
					checked: survey.visibility
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
